import styled from "styled-components";

export const StyledIntro = styled.div`
  height: 100vh;
  width: 100vw;
  div.container {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    flex-direction: column;
    height: 100vh;
    width: 100vw;
    div:nth-of-type(1) {
      font-size: 8rem;
      @media screen and (max-width: 850px) {
        font-size: 6rem;
      }
      @media screen and (max-width: 620px) {
        font-size: 4rem;
      }
      @media screen and (max-width: 450px) {
        font-size: 3rem;
      }
    }
    div:nth-of-type(2) {
      font-size: 3rem;
      font-style: italic;
      top: 50%;
      @media screen and (max-width: 850px) {
        font-size: 2rem;
      }
      @media screen and (max-width: 620px) {
        font-size: 1.5rem;
      }
      @media screen and (max-width: 450px) {
        font-size: 1rem;
      }
    }
    div:nth-of-type(3) {
      font-size: 4rem;
      font-style: Bold;
      @media screen and (max-width: 850px) {
        font-size: 3rem;
      }
      @media screen and (max-width: 620px) {
        font-size: 2.5rem;
      }
      @media screen and (max-width: 450px) {
        font-size: 2rem;
      }
    }
  }

  div.loadingBar {
    height: 2rem;
    width: 8rem;
    background: red;
    top: 90%;
  }
`;
